import { Route, Routes } from 'react-router-dom';
import RoleManagementPage from './role-management';

const RoleManagementRouter: React.FC = () => {
  return(
  <Routes>
    <Route path="/" element={<RoleManagementPage />} />
  </Routes>
  )
}

export default RoleManagementRouter
